import { ID } from 'shared/types/id';
import { goalInboxID } from 'shared/types/orderable-section';
import { HabitSortingMode } from 'shared/types/sorting-mode';

import { getUser, getUserRef } from './get-user';
import { updateDocWithTimestamp } from './helpers';

export const updateHabitGoalTaskOrder = async (
  goalSorting: { goalId: ID; taskIds: ID[] }[],
) => {
  const user = await getUser();
  // without a user we cannot update anything.
  if (!user) {
    return;
  }

  const userRef = await getUserRef();

  if (!userRef) {
    return;
  }

  const settingsToUpdate = goalSorting.reduce<
    Record<string, ID[] | HabitSortingMode>
  >(
    (acc, { goalId, taskIds }) => {
      acc[
        `settings.habitGroupSorting.goal.sorting.${goalId === goalInboxID ? null : goalId}`
      ] = taskIds;
      return acc;
    },
    {
      'settings.habitSortingMode': HabitSortingMode.Custom,
    },
  );

  updateDocWithTimestamp(userRef, settingsToUpdate);
};
